import React, { useEffect, useState } from "react";
import { FaFrownOpen } from "react-icons/fa";
import { Helmet } from 'react-helmet-async';


const Gallery = () => {
 let [data,setData]=useState([])

  const [selectedGallery, setSelectedGallery] = useState(null);
  const [zoomedImage, setZoomedImage] = useState(null);

  const handleOpenModal = (gallery) => {
    setSelectedGallery(gallery);
  };

  const handleCloseModal = () => {
    setSelectedGallery(null);
    setZoomedImage(null);
  };


async function getApiData() {
  try {
    let response = await fetch("https://vhotelbackend.onrender.com/api/gallery", {
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    });

    response = await response.json();

    if (response.result === "Done") {
      setData(response.data);
    } else {
    }
  } catch (error) {
    console.error("API Error:", error); 
  }
}


useEffect(() => {
  getApiData();
}, []);

useEffect(() => {
}, [data]);



  return (
    <>

{/* SEO Tags */}
      <Helmet>
        <title>Hotel Image Near Delhi Airport | V Hotel The Grand Shoba</title>
        <meta
          name="description"
          content="Browse hotel images near Delhi Airport at V Hotel The Grand Shoba. View stylish rooms, modern amenities, and elegant interiors before you book your stay."
        />
        <meta name="keywords" content="Hotel Image Near Delhi Airport" />
        <link rel="canonical" href="https://www.vhotelthegrandshoba.com/gallery
        "/>
        <meta name="robots" content="index, follow" />

      </Helmet>

      <div className="gallery-h2">
        <h1 className="text-center mb-4">Our Gallery </h1>
      </div>
       <h1 className="text-center " style={{color:"#856a2b", fontFamily:"Cinzel" , paddingTop:"20px", paddingBottom:"35px"}}>Hotel Image Near Delhi Airport</h1>
      {
        data.length?

        <div className="container py-5">
        <div className="row g-4">
          {data.map((item, idx) => (
            <div className="col-12 col-sm-6 col-lg-4" key={idx}>
              <div
                className="card gallery-card border-0 shadow-sm h-100"
                onClick={() => handleOpenModal(item.pic)}
                style={{ cursor: "pointer" }}
              >
                <div className="overflow-hidden  m-auto gallery-img-div" style={{width:"100%"}}>
                  <img
                    src={`https://vhotelbackend.onrender.com${item.pic[0]}`}
                    title="V Hotel The Grnad Shoba Gallery"
                    loading="lazy"
                    alt={`V Hotel The Grnad Shoba ${item.name}`}
                    className="card-img-top  gallery-img"
                    style={{width:"95%"}}
                  />
                </div>
                <div className="card-body text-center">
                  <h5 className="card-title">{item.name}</h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      :
     <div className="not-testinomonil mt-3 mb-3">
                    <h3 style={{color:"#856a2b"}}>Sorry! <FaFrownOpen /> Images Record Not Found!!</h3>
                    
                  </div>
      }

      {selectedGallery && (
        <div className="custom-modal-backdrop" onClick={handleCloseModal}>
          <div
            className="custom-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={handleCloseModal}>
              ×
            </button>

            <div className=" mx-5 gap-2 justify-content-center">
              {selectedGallery.map((img, i) => (
                <img
                  key={i}
                  src={`https://vhotelbackend.onrender.com${img}`}
                  alt={`img-${i}`}
                  className="modal-thumb mx-2 my-2"
                  onClick={() => setZoomedImage(img)}
                />
              ))}
            </div>

            {zoomedImage && (
              <div className="zoomed-image-container" onClick={() => setZoomedImage(null)}>
                <img src={`https://vhotelbackend.onrender.com${zoomedImage}`} loading="lazy" alt="Zoomed-images" className="zoomed-image" />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
